<div *ngIf="this.incomeTaxEntity.aangifte?.persoonsgebondenAftrek?.pgaSpecifiekeZorgkosten &&
            Object.keys(this.incomeTaxEntity.aangifte?.persoonsgebondenAftrek?.pgaSpecifiekeZorgkosten || {}).length > 0">
    <form [formGroup]="specZorgkostenFormGroup">
        <div formGroupName="specificatieZorgkosten">
            <div formGroupName="opbouw">
                <div>
                    <div>
                        <div
                                *ngIf="specZorgkostenFormGroup.get(['specificatieZorgkosten', 'opbouw', 'behandelKosten'])?.value > 0">
                            <div class="row">
                                <div class="col col-1">
                                    <p>Behandelkosten</p>
                                </div>
                                <div class="col-2">
                                    <snelstart-ui-number-form-control
                                            formControlName="behandelKosten"
                                            id="behandelKosten"
                                            class="custom-input-150"
                                            [decimals]="0"
                                            prefix="€"
                                            align="right"
                                    ></snelstart-ui-number-form-control>
                                </div>
                                <div class="col-2"></div>
                                <div class="col-2"></div>
                            </div>
                        </div>
                        <div
                                *ngIf="specZorgkostenFormGroup.get(['specificatieZorgkosten', 'opbouw', 'medicijnKosten'])?.value > 0">
                            <div class="row">
                                <div class="col col-1">
                                    <p>Medicijnkosten</p>
                                </div>
                                <div class="col-2">
                                    <snelstart-ui-number-form-control
                                            formControlName="medicijnKosten"
                                            id="medicijnKosten"
                                            class="custom-input-150"
                                            [decimals]="0"
                                            prefix="€"
                                            align="right"
                                    ></snelstart-ui-number-form-control>
                                </div>
                                <div class="col-2"></div>
                                <div class="col-2"></div>
                            </div>
                        </div>
                        <div
                                *ngIf="specZorgkostenFormGroup.get(['specificatieZorgkosten', 'opbouw', 'hulpmiddelen'])?.value > 0">
                            <div class="row">
                                <div class="col col-1">
                                    <p>Hulpmiddelen</p>
                                </div>
                                <div class="col-2">
                                    <snelstart-ui-number-form-control
                                            formControlName="hulpmiddelen"
                                            id="hulpmiddelen"
                                            class="custom-input-150"
                                            [decimals]="0"
                                            prefix="€"
                                            align="right"
                                    ></snelstart-ui-number-form-control>
                                </div>
                                <div class="col-2"></div>
                                <div class="col-2"></div>
                            </div>
                        </div>
                        <div
                                *ngIf="specZorgkostenFormGroup.get(['specificatieZorgkosten', 'opbouw', 'aftrekbaarExtraGezinshulp'])?.value > 0">
                            <div class="row">
                                <div class="col col-1">
                                    <p>Kosten extra gezinshulp</p>
                                </div>
                                <div class="col-2">
                                    <snelstart-ui-number-form-control
                                            formControlName="aftrekbaarExtraGezinshulp"
                                            id="aftrekbaarExtraGezinshulp"
                                            class="custom-input-150"
                                            [decimals]="0"
                                            prefix="€"
                                            align="right"
                                    ></snelstart-ui-number-form-control>
                                </div>
                                <div class="col-2"></div>
                                <div class="col-2"></div>
                            </div>
                        </div>
                        <div
                                *ngIf="specZorgkostenFormGroup.get(['specificatieZorgkosten', 'opbouw', 'reiskostenEigenZorg'])?.value > 0">
                            <div class="row">
                                <div class="col col-1">
                                    <p>Reiskosten eigen zorg</p>
                                </div>
                                <div class="col-2">
                                    <snelstart-ui-number-form-control
                                            formControlName="reiskostenEigenZorg"
                                            id="reiskostenEigenZorg"
                                            class="custom-input-150"
                                            [decimals]="0"
                                            prefix="€"
                                            align="right"
                                    ></snelstart-ui-number-form-control>
                                </div>
                                <div class="col-2"></div>
                                <div class="col-2"></div>
                            </div>
                        </div>
                        <div
                                *ngIf="specZorgkostenFormGroup.get(['specificatieZorgkosten', 'opbouw', 'reiskostenGezinslid'])?.value > 0">
                            <div class="row">
                                <div class="col col-1">
                                    <p>Reiskosten ziek gezinslid</p>
                                </div>
                                <div class="col-2">
                                    <snelstart-ui-number-form-control
                                            formControlName="reiskostenGezinslid"
                                            id="reiskostenGezinslid"
                                            class="custom-input-150"
                                            [decimals]="0"
                                            prefix="€"
                                            align="right"
                                    ></snelstart-ui-number-form-control>
                                </div>
                                <div class="col-2"></div>
                                <div class="col-2"></div>
                            </div>
                        </div>
                        <div
                                *ngIf="specZorgkostenFormGroup.get(['specificatieZorgkosten', 'opbouw', 'kledingEnBeddengoed'])?.value > 0">
                            <div class="row">
                                <div class="col col-1">
                                    <p>Aftrek extra kosten kleding en beddengoed</p>
                                </div>
                                <div class="col-2">
                                    <snelstart-ui-number-form-control
                                            formControlName="kledingEnBeddengoed"
                                            id="kledingEnBeddengoed"
                                            class="custom-input-150"
                                            [decimals]="0"
                                            prefix="€"
                                            align="right"
                                    ></snelstart-ui-number-form-control>
                                </div>
                                <div class="col-2"></div>
                                <div class="col-2"></div>
                            </div>
                        </div>
                        <div
                                *ngIf="specZorgkostenFormGroup.get(['specificatieZorgkosten', 'opbouw', 'dieetkosten'])?.value > 0">
                            <div class="row">
                                <div class="col col-1">
                                    <p>Dieetkosten</p>
                                </div>
                                <div class="col-2">
                                    <snelstart-ui-number-form-control
                                            formControlName="dieetkosten"
                                            id="dieetkosten"
                                            class="custom-input-150"
                                            [decimals]="0"
                                            prefix="€"
                                            align="right"
                                    ></snelstart-ui-number-form-control>
                                </div>
                                <div class="col-2"></div>
                                <div class="col-2"></div>
                            </div>
                        </div>
                        <div
                                *ngIf="specZorgkostenFormGroup.get(['specificatieZorgkosten', 'opbouw', 'totaalZorgkostenVoorVerhoging'])?.value > 0">
                            <div class="row">
                                <div class="col col-1">
                                    <p>Totale zorgkosten</p>
                                </div>
                                <div class="col-2">
                                    <snelstart-ui-number-form-control
                                            formControlName="totaalZorgkostenVoorVerhoging"
                                            id="totaalZorgkostenVoorVerhoging"
                                            class="custom-input-150"
                                            [decimals]="0"
                                            prefix="€"
                                            align="right"
                                    ></snelstart-ui-number-form-control>
                                </div>
                                <div class="col-2"></div>
                                <div class="col-2"></div>
                            </div>
                        </div>
                        <div
                                *ngIf="specZorgkostenFormGroup.get(['specificatieZorgkosten', 'opbouw', 'verhogingZorgkosten'])?.value > 0">
                            <div class="row">
                                <div class="col col-1">
                                    <p>Bij: Verhoging</p>
                                </div>
                                <div class="col-2">
                                    <snelstart-ui-number-form-control
                                            formControlName="verhogingZorgkosten"
                                            id="verhogingZorgkosten"
                                            class="custom-input-150"
                                            [decimals]="0"
                                            prefix="€"
                                            align="right"
                                    ></snelstart-ui-number-form-control>
                                </div>
                                <div class="col-2"></div>
                                <div class="col-2"></div>
                            </div>
                        </div>
                        <div
                                *ngIf="specZorgkostenFormGroup.get(['specificatieZorgkosten', 'opbouw', 'verhogingZorgkosten'])?.value > 0">
                            <div class="row">
                                <div class="col col-1">
                                </div>
                                <div class="col-2">
                                    <snelstart-ui-number-form-control
                                            formControlName="zorgkostenVoorDrempel"
                                            id="zorgkostenVoorDrempel"
                                            class="custom-input-150"
                                            [decimals]="0"
                                            prefix="€"
                                            align="right"
                                    ></snelstart-ui-number-form-control>
                                </div>
                                <div class="col-2"></div>
                                <div class="col-2"></div>
                            </div>
                        </div>
                        <div
                                *ngIf="specZorgkostenFormGroup.get(['specificatieZorgkosten', 'opbouw', 'drempelZorgkosten'])?.value > 0">
                            <div class="row">
                                <div class="col col-1">
                                    <p>Af: Drempel</p>
                                </div>
                                <div class="col-2">
                                    <snelstart-ui-number-form-control
                                            formControlName="drempelZorgkosten"
                                            id="drempelZorgkosten"
                                            class="custom-input-150"
                                            [decimals]="0"
                                            prefix="€ -"
                                            align="right"
                                    ></snelstart-ui-number-form-control>
                                </div>
                                <div class="col-2"></div>
                                <div class="col-2"></div>
                            </div>
                        </div>
                        <div
                                *ngIf="specZorgkostenFormGroup.get(['specificatieZorgkosten', 'opbouw', 'totaalZorgkostenVoorVerhoging'])?.value > 0">
                            <div class="row">
                                <div class="col col-1">
                                    <p><b>Aftrekbare zorgkosten</b></p>
                                </div>
                                <div class="col-2">
                                    <snelstart-ui-number-form-control
                                            formControlName="aftrekbareZorgkosten"
                                            id="aftrekbareZorgkosten"
                                            class="custom-input-150"
                                            [decimals]="0"
                                            placeholder="-"
                                            prefix="€"
                                            align="right"
                                    ></snelstart-ui-number-form-control>
                                </div>
                                <div class="col-2"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>

